import detail01 from "../assets/images/sub/partnership/1.png";
import detail02 from "../assets/images/sub/partnership/2.jpg";
import detail03 from "../assets/images/sub/partnership/3.jpg";
import detail04 from "../assets/images/sub/partnership/4.jpg";
import detail05 from "../assets/images/sub/partnership/5.jpg";
import detail06 from "../assets/images/sub/partnership/6.jpg";
import detail07 from "../assets/images/sub/partnership/7.jpg";
import detail08 from "../assets/images/sub/partnership/8.jpg";
import detail09 from "../assets/images/sub/partnership/9.jpg";
import detail10 from "../assets/images/sub/partnership/10.gif";
import detail11 from "../assets/images/sub/partnership/11.gif";
import detail12 from "../assets/images/sub/partnership/12.jpg";

import detail01En from "../assets/images/sub/partnership/1_en.png";
import detail02En from "../assets/images/sub/partnership/2_en.jpg";
import detail03En from "../assets/images/sub/partnership/3_en.jpg";
import detail04En from "../assets/images/sub/partnership/4_en.jpg";
import detail05En from "../assets/images/sub/partnership/5_en.jpg";
import detail06En from "../assets/images/sub/partnership/6_en.jpg";
import detail07En from "../assets/images/sub/partnership/7_en.jpg";
import detail08En from "../assets/images/sub/partnership/8_en.gif";
import detail09En from "../assets/images/sub/partnership/9_en.gif";
import detail10En from "../assets/images/sub/partnership/10_en.jpg";
import { useMemo } from "react";
import { DetailFileType, FileCategory } from "../types/file";

export function usePartnershipDetailImages() {
    const detailImages: DetailFileType[] = useMemo(
        () => [
            { type: FileCategory.IMAGE, url: detail01 },
            { type: FileCategory.IMAGE, url: detail02 },
            { type: FileCategory.IMAGE, url: detail03 },
            { type: FileCategory.IMAGE, url: detail04 },
            { type: FileCategory.IMAGE, url: detail05 },
            { type: FileCategory.IMAGE, url: detail06 },
            { type: FileCategory.IMAGE, url: detail07 },
            { type: FileCategory.IMAGE, url: detail08 },
            { type: FileCategory.IMAGE, url: detail09 },
            { type: FileCategory.IMAGE, url: detail10 },
            { type: FileCategory.IMAGE, url: detail11 },
            { type: FileCategory.IMAGE, url: detail12 },
        ],
        []
    );

    const detailEnImages: DetailFileType[] = useMemo(
        () => [
            { type: FileCategory.IMAGE, url: detail01En },
            { type: FileCategory.IMAGE, url: detail02En },
            { type: FileCategory.IMAGE, url: detail03En },
            { type: FileCategory.IMAGE, url: detail04En },
            { type: FileCategory.IMAGE, url: detail05En },
            { type: FileCategory.IMAGE, url: detail06En },
            { type: FileCategory.IMAGE, url: detail07En },
            { type: FileCategory.IMAGE, url: detail08En },
            { type: FileCategory.IMAGE, url: detail09En },
            { type: FileCategory.IMAGE, url: detail10En },
        ],
        []
    );
  return {
      detailImages, detailEnImages
  };
}
